import soda1 from './soda1.png'
import soda2 from './soda2.png'
import soda3 from './soda3.png'
import soda4 from './soda4.png'
import juice1 from './juice1.png'
import juice2 from './juice2.png'
import juice3 from './juice3.png'
import juice4 from './juice4.png'
import coffee1 from './coffee1.png'
import coffee2 from './coffee2.png'
import coffee3 from './coffee3.png'
import coffee4 from './coffee4.png'
import tea1 from './tea1.png'
import tea2 from './tea2.png'
import tea3 from './tea3.png'
import tea4 from './tea4.png'

export const soda = [
  { url: soda1, name: '칠성사이다' },
  { url: soda2, name: '펩시' },
  { url: soda3, name: '마운틴듀' },
  { url: soda4, name: '미린다' },
]

export const juice = [
  { url: juice1, name: '포켓몬 포도사과' },
  { url: juice2, name: '오리지널 매실' },
  { url: juice3, name: '망고코코' },
  { url: juice4, name: '트로피카나 망고제주감귤' },
]

export const coffee = [
  { url: coffee1, name: '칸타타블랙' },
  { url: coffee2, name: '레쓰비마일드' },
  { url: coffee3, name: '칸타타콜레컨트롤' },
  { url: coffee4, name: '레쓰비카페타임' },
]

export const tea = [
  { url: tea1, name: '초가을 우엉차' },
  { url: tea2, name: '황금보리' },
  { url: tea3, name: '옥수수수염차' },
  { url: tea4, name: '립톤' },
]
